// extracted by mini-css-extract-plugin
export default {"authLayout":"AuthLayout_authLayout__RcK1t","boxHolder":"AuthLayout_boxHolder__q03hD","rightCol":"AuthLayout_rightCol__TJtWQ","leftCol":"AuthLayout_leftCol__MPP9b"};